import { SET_USER_EMAIL } from "../../constants";

export const getVerifiedEmail = (state: any = null, action: any) => {
  switch (action.type) {
    case SET_USER_EMAIL:
      return action.payload;
    default:
      return state;
  }
};
